<template>
  <div class="content">
    <p style="font-weight: bold;font-size: 24px;    margin-bottom: 25px !important;">Calendário de Obrigações {{$store.state.nomeObri}}</p>
    <div v-if="!$store.getters.conteudo.ativo">
     
     <p>Nenhuma obrigação cadastrada para o mês selecionado.</p>
    </div>
    <div v-else>
         <div v-html="$store.getters.conteudo.notaInicio" style="font-size:0.9em;" v-show="$store.getters.calendarioCompleto">
    </div>
      <el-timeline  >
        <el-timeline-item v-for="(n, index) in $store.getters.conteudo" :key="index" v-show="n.length != 0 & index<=31" >          
          <div v-if="index<=31">
              <div v-if="n.length != 0">
              <p class="dia" :id="index">{{index >=10 ? index : '0'+index}}/{{$store.getters.mes >=10 ? $store.getters.mes : '0'+$store.getters.mes}}/{{$store.getters.ano}}</p>
              <div  v-for="(c, j) in n" :key="j"  >                
                  <p class="cat">{{c.categoria}}</p>
                  <div style="margin-left: 20px;">
                    <p v-html="c.descCategoria" class="cat"></p>
                  <p v-html="c.obrigacao" v-show="$store.getters.calendarioCompleto"></p>
                  <table v-show="$store.getters.calendarioCompleto && c.dark.length != 0" style="margin-top:10px;">
                      <tr>
                          <th>Descrição</th>
                          <th>DARF</th>
                      </tr>
                      <tr v-for="(dar,k) in c.dark" :key="k">
                          <td>{{dar.obs}}</td>
                          <td>{{dar.darf}}</td>
                      </tr>
                  </table> 
                  </div>
                  <div style="display: flex;" v-if="j+1 != n.length">
                     <hr style="width: 50%;border-color: rgb(162 162 162); ">  
                  </div>       
              </div>
            </div>
          </div>          
        </el-timeline-item>
      </el-timeline> 
        <hr style="width: 50%;border-color: rgb(162 162 162); ">   
      <div v-html="$store.getters.conteudo.notaFim" v-show="$store.getters.calendarioCompleto" style="font-size:0.9em;">
      </div>
    </div>
    
  </div>
</template>

<script>
export default {

}
</script>

<style>
.el-timeline-item {
    position: relative;
    padding-bottom: 12px;
    padding-top: 12px;
}
.fontIcones{
  display: none;
}

.col-md-12 p{
  font-size: 14px;
}

.descricao {
    margin-left: 35px;
    font-size: 14px;
}

p{
  margin-bottom: 0px !important;
}
h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0px;
    margin-left: 13px;
}
h2{
  font-size: 14px;
    font-weight: bold;
    margin-top: 5px;
    margin-bottom: 0px;
    margin-left: 35px;
}
.data {
    color: #2D4EBF;
    margin-left: 0px;
    font-size: 20px;
    padding-left: 15px;
}
.content{
    grid-area: content;	  
    padding:20px;
    height: 87vh;
    overflow-y:auto;
}
.content::-webkit-scrollbar-thumb {
    background-color: #595559;
    border-radius: 10px;
} 
.content::-webkit-scrollbar-track {
  background: #f2f2f2;   
}
.content::-webkit-scrollbar {
    width: 12px;    
}
.content .dia {
    font-size: 22px;
    font-weight: 800 !important; 
    color: #1d3b53 !important;
    padding-bottom: 15px;
}
.content .cat{
    font-weight: bold;
    margin-bottom: 0px;
}
.content table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.content td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #f5f5f5;
}
</style>